import React from "react";
import dynamic from "next/dynamic";
const SectionTitle = dynamic(() =>
  import("components/typography/SectionTitle/SectionTitle")
);
import styles from "./TwoCol.module.scss";

export default function TwoCol({
  title,
  headingTag,
  column1Content,
  column2Content,
  column1Position,
}) {
  // Create a React element based on a string of type h1-h6
  const titleElement = React.createElement(
    headingTag,
    null,
    <SectionTitle title={title} />
  );

  return (
    <section className={`${styles.container} wn-dynamic-row`}>
      {title && titleElement}
      <div
        className={`${styles.columns} ${
          column1Position === "left" ? styles.column1Right : ""
        }`}
      >
        <div className={`${styles.column} ${styles.column1}`}>
          {column1Content && column1Content}
        </div>
        <div className={` ${styles.column} ${styles.column2}`}>
          {column2Content && column2Content}
        </div>
      </div>
    </section>
  );
}
